import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3940190096/src/nuxt/layouts/default.vue").then(m => m.default || m)),
  guest: defineAsyncComponent(() => import("/codebuild/output/src3940190096/src/nuxt/layouts/guest.vue").then(m => m.default || m))
}